module.exports = __webpack_public_path__ + "media/video-poster/poster-mobile-56d1bf70.jpg";